export const INPUT_NOT_DEFINED = "";
export const NO_CONTENT = "-";
export const EMPTY_TOOLTIP = "";

export const PATH_DTWINS = "/dtwins";
export const PATH_DTWINS_ID = `${PATH_DTWINS}/:id`;
export const PATH_DTWINS_ID_CONFIGURATION = `${PATH_DTWINS_ID}/configuration`;
export const PATH_DTWINS_ID_CONFIGURATION_OPERATION_UID_STEPS = `${PATH_DTWINS_ID_CONFIGURATION}/operation/:operationUid/steps`;
export const PATH_DTWINS_ID_MODULES = `${PATH_DTWINS_ID}/modules`;
export const PATH_DTWINS_ID_DATA_VISUALISATION = `${PATH_DTWINS_ID}/data-visualisation`;
export const PATH_DTWINS_ID_DESCRIPTION = `${PATH_DTWINS_ID}/description`;
export const PATH_DTWINS_ID_CERTIFICATE = `${PATH_DTWINS_ID}/certificate`;
export const PATH_DTWINS_ID_CERTIFICATE_OPERATION_UID_STEPS = `${PATH_DTWINS_ID_CERTIFICATE}/operation/:operationUid/steps`;
export const PATH_DTWINS_ID_FIRMWARE = `${PATH_DTWINS_ID}/firmware`;
export const PATH_DTWINS_ID_FIRMWARE_OPERATION_UID_STEPS = `${PATH_DTWINS_ID_FIRMWARE}/operation/:operationUid/steps`;
export const PATH_DTWINS_ID_LOGS = `${PATH_DTWINS_ID}/logs`;
export const PATH_DTWINS_ID_ADDITIONAL_METADATA = `${PATH_DTWINS_ID}/additional-metadata`;

export const FILTER_OPTION_TYPE_SEPARATOR = ",";
export const FILTER_OPTION_RANGE_SEPARATOR = "||";

export const COMPONENT_ID_BS_TRANSLATION_UI_CONFIG =
  "lxc-bs-translation-ui-config";

/**
 * Key used to get distinct values for lifecycle
 */
export const DISTINCT_VALUES_LIFECYCLE = "lifeCycleState";
